
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class AccessRequestDialog extends Vue {
  @Prop(String) accessGloboRuleName?: string;
  showAccessGloboDialog = false;
  urlAcessRequest = 'https://acesso.g.globo';

  get tooltipTextCopy(): string {
    return `Copiar ${this.accessGloboRuleName}`;
  }

  handleRequestAccess(): void {
    window.open(this.urlAcessRequest, '_blank');
    this.showAccessGloboDialog = false;
  }
  async copyToClipboard(text: string): Promise<void> {
    try {
      await navigator.clipboard.writeText(text);
      this.showClipboardToast(true);
    } catch (erro) {
      console.error('Erro ao copiar:', erro);
      this.showClipboardToast(false);
    }
  }
  showClipboardToast(success: boolean) {
    const message = success
      ? 'Permissão copiada!'
      : 'Falha ao copiar a permissão.';
    const type = success ? 'success' : 'danger';
    this.$store.commit('showAlert', {
      message: message,
      type: type,
      timeout: 5,
    });
  }
}
